module.exports = __webpack_public_path__ + "static/media/our-partner-first.28040af1.svg";